export const tabList = [
  {
    key: "Logros",
    label: "Logros",
  },
  {
    key: "RequerimientosEvoluciones",
    label: "Requerimientos evoluciones",
  },
  {
    key: "Roles",
    label: "Roles",
  },

  {
    key: "Objetos",
    label: "Objetos",
  },

  {
    key: "TipoImagen",
    label: "Tipo Imagen",
  },

];
